import React, { useState } from 'react';
import './VAR.css';
import './MarketRisk.css';
import PageShell from '../components/layout/PageShell';
import PreTradeVar from '../components/common/PreTradeVar';

type ViewType = 'pre_trade' | string | null;

const VAR: React.FC = () => {
  const [activeView, setActiveView] = useState<ViewType>('pre_trade');

  return (
    <PageShell>
      <nav className="nav-bar">
        <div
          className={`nav-item ${activeView === 'pre_trade' ? 'active' : ''}`}
          onClick={() => setActiveView('pre_trade')}
        >
          Pre-Trade Analysis
        </div>
      </nav>

      <div className="view-stack">
        <div className={`view-pane ${activeView === 'pre_trade' ? 'is-active' : ''}`}>
          <div className="market-risk-content-container">
            <button className="close-button" onClick={() => setActiveView(null)}>×</button>
            <PreTradeVar />
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default VAR;